import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh.json'

const userLang = navigator.language.toLowerCase()
const defaultLocale = userLang.startsWith('zh') ? 'zh' : 'en'

const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    zh
  }
})

const app = createApp(App)

const link = document.createElement('link')
link.rel = 'icon'
link.href = '/logo-bytescape-web.svg'
link.type = 'image/svg+xml'
document.head.appendChild(link)
document.title = i18n.global.t("html.title")

app.use(i18n)
app.mount('#app')
